import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6e508deb&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e508deb')) {
      api.createRecord('6e508deb', component.options)
    } else {
      api.reload('6e508deb', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6e508deb&", function () {
      api.rerender('6e508deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/imageCarousel.vue"
export default component.exports